import React, {useEffect, useRef, useState} from 'react'
import Input from 'components/UI/input/Input'
import {ReactComponent as SaveIcon} from '@/assets/svgs/SaveIcon.svg'
import {colors} from '@/constants'

const EditInputProps = ({
  svgIcon,
  onIconClick,
  onFocusLost,
  schema,
  iconFill = colors.orange,
  ...textFieldProps
}: any) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const [isDisabled, setDisabled] = useState(true)
  const [saveIcon, setSaveIcon] = useState(true)

  const handleIconClick = () => {
    setDisabled(false)
    setSaveIcon(false)
  }

  useEffect(() => {
    const handleBlur = () => {
      setSaveIcon(false)
      if (onFocusLost) {
        setSaveIcon(true)
        setDisabled(true)
        onFocusLost()
      }
    }

    const inputElement = inputRef.current
    if (inputElement) {
      inputElement.addEventListener('blur', handleBlur)
    }

    return () => {
      if (inputElement) {
        inputElement.removeEventListener('blur', handleBlur)
      }
    }
  }, [onFocusLost])

  useEffect(() => {
    if (!isDisabled) {
      if (inputRef.current) {
        inputRef.current.focus()
      }
    }
  }, [isDisabled])

  return (
    <Input
      disabledcolor={colors.white}
      disabled={isDisabled}
      {...textFieldProps}
      inputRef={inputRef}
      InputProps={{
        endAdornment: (
          <div onClick={handleIconClick} style={{cursor: 'pointer'}}>
            {saveIcon ? (
              svgIcon
            ) : (
              <SaveIcon style={{fill: iconFill}} width="19px" />
            )}
          </div>
        ),
      }}
      {...schema}
    />
  )
}

export default EditInputProps
